import { ProgressBar } from '@shopify/polaris';
import { useState, useEffect } from 'react';

function ProgressAnimation() {
  const [progress, setProgress] = useState(25); // Start at 25%

  useEffect(() => {
    // Set up the animation to reach 100% in 4 seconds
    const totalDuration = 6000; // 4 seconds in milliseconds
    const incrementInterval = 100; // Update every 50ms for smoothness
    const totalIncrements = totalDuration / incrementInterval; // Total steps (80)
    const increment = (100 - 25) / totalIncrements; // Increment per step (0.9375)

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + increment;
        if (newProgress >= 100) {
          clearInterval(interval); // Stop when reaching 100%
          return 100;
        }
        return newProgress;
      });
    }, incrementInterval);

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <ProgressBar progress={progress} size="medium" />
  );
}

export default ProgressAnimation;